import gql from 'graphql-tag';

/**
 * Data of the block project-plant-data ("Anlagedaten"): the twelve stored fields of
 * `investmentDeductionAllowance` and the computed EEG tariff. Read through
 * `Project.blocks.plantData`, which checks the block's read permission.
 */
export const PROJECT_PLANT_DATA_FIELDS = gql`
  fragment projectPlantDataFields on ProjectPlantDataBlock {
    id
    number
    investmentDeductionAllowance {
      installationType
      areaInSquareMeters
      specificAnnualYieldKwhPerKwp
      initialFeedInTariffDurationYears
      feedInTariffGuaranteeCaseEurPerKwh
      feedInTariffMedianCaseEurPerKwh
      feedInTariffOptimalCaseEurPerKwh
      expectedFeedInTariffIncreasePercentPerYear
      degradationPercentPerYear
      annualOperatingCostPerKwpEur
      annualLeaseType
      annualLeasePercent
      calculatedEEGfeedInTariffEurPerKwh
    }
  }
`;
